module.exports = __webpack_public_path__ + "static/img/fxlh.3988a54.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fxlh.png
// module id = 2Qi6
// module chunks = 0